import { Component, OnInit, OnDestroy } from "@angular/core";
import * as moment from "moment";
import { CancelSubscriptionService } from "./services/cancel-subscription.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';
@Component({
  selector: "ch-cancel-subscription",
  templateUrl: "./cancel-subscription.component.html",
  styleUrls: ["./cancel-subscription.component.css"]
})
export class CancelSubscriptionComponent implements OnInit, OnDestroy {
  public subscriptionData: any = {};
  public submited = false;
  public formLocked = false;
  constructor(private cancelSubscriptionService: CancelSubscriptionService, private titleService: Title) {
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`Cancel Subscription | CODE Hospitality CMS`);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public submit(form) {
    this.submited = true;
    if (!form.valid || this.isStartDateIsBigger()) {
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }
      return;
    }
    this.formLocked = true;
    this.cancelSubscriptionService
      .cancelSubscription(this.subscriptionData)
      .subscribe(
        (_: any) => {
          this.formLocked = false;
          this.alertSuccess();
        },
        (error: any) => {
          this.formLocked = false;
          this.alertError(error);
        }
      );
  }

  isStartDateIsBigger() {
    if (this.subscriptionData.startDate && this.subscriptionData.endDate) {
      return (
        moment(this.subscriptionData.startDate).format("x") >
        moment(this.subscriptionData.endDate).format("x")
      );
    }
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }

  private alertSuccess() {
    alertify.success(`Request successful.`);
  }

  public startDateChange(newStartDate): void {
    this.subscriptionData.startDate = moment(newStartDate).format("YYYY-MM-DD");
  }

  public endDateChange(newEndDate): void {
    this.subscriptionData.endDate = moment(newEndDate).format("YYYY-MM-DD");
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/cancel-subscription/cancel-subscription.component.ts